import { render } from "./indexTestimonial.vue?vue&type=template&id=edede8f8"
import script from "./indexTestimonial.vue?vue&type=script&lang=js"
export * from "./indexTestimonial.vue?vue&type=script&lang=js"

import "./indexTestimonial.vue?vue&type=style&index=0&id=edede8f8&lang=css"

import exportComponent from "/home/afreet/public_html/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__